<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        {{ header }}
      </div>
      <button
        class="ac-close-button"
        @click="toggleActionModal(true, 'new-order')"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <SACInput
        class="margin-bottom"
        field="address1"
        placeholder="Enter Street Address"
        :value="nAddress.address1"
        :change="(field, value) => changeAddressInfo(field, value)"
      />
      <SACInput
        class="margin-bottom"
        field="address2"
        placeholder="Enter Apt #, Suite #, etc"
        :value="nAddress.address2"
        :change="(field, value) => changeAddressInfo(field, value)"
      />
      <SACInput
        class="margin-bottom"
        field="city"
        placeholder="Enter City"
        :value="nAddress.city"
        :change="(field, value) => changeAddressInfo(field, value)"
      />
      <SACDropdown
        class="margin-bottom"
        :options="states"
        :value="nAddress.state"
        optionLabel="state"
        optionValue="abbreviation"
        placeholder="Select State"
        field="state"
        :change="(field, value) => changeAddressInfo(field, value)"
      />
      <SACInput
        field="zip"
        placeholder="Enter Zip"
        :value="nAddress.zip"
        :change="(field, value) => changeAddressInfo(field, value)"
      />
    </div>
    <div class="ac-footer-container">
      <button
        class="ac-form-button"
        @click="toggleActionModal(true, 'new-order')"
      >
        Cancel
      </button>
      <button
        class="ac-form-button"
        @click="saveAddressInfo"
      >
        Save
      </button>
    </div>
  </div>
</template>

<script>
import orderMixin from '@shared/mixins/orderMixin';

import SACInput from '@shared/components/sac/SACInput.vue';
import SACDropdown from '@shared/components/sac/SACDropdown.vue';

export default {
  name: 'EditAddress',
  components: {
    SACInput,
    SACDropdown,
  },
  mixins: [orderMixin],
  computed: {
    header() {
      if (this.actionModalView.includes('shipping')) {
        return 'Edit Shipping Address';
      }
      return 'Edit Billing Address';
    },
  },
  methods: {
    changeAddressInfo(field, value) {
      let nAddress = {
        ...this.nAddress,
        [field]: value,
      };
      if (field === 'address') {
        nAddress = {
          ...value,
        };
      }
      this.changeOrderValue('nAddress', nAddress);
    },
    saveAddressInfo() {
      const newOrder = {
        ...this.newOrder,
      };
      if (this.actionModalView.includes('shipping')) {
        newOrder.shippingAddress = this.nAddress;
      } else if (this.actionModalView.includes('billing')) {
        newOrder.billingAddress = this.nAddress;
      }
      this.changeOrderValue('newOrder', newOrder);
      this.toggleActionModal(true, 'new-order');
    },
  },
};
</script>
